import { MainRoutes } from "./MainRoutes";
import { QuoterRoutes } from "./QuoterRoutes";
//import { ApplicationRoutes } from "./ApplicationRoutes";

export const AppRoutes = [
  ...MainRoutes,
  ...QuoterRoutes,
  //...ApplicationRoutes
];
